import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TopBar from "../components/layout/topbar";
import Footer from "../components/layout/footer";

const PrivateRoute = () => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);

  if (!isLoggedIn || (user && user.role !== "ADMIN")) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="d-flex flex-column min-vh-100">
      <ToastContainer />
      <TopBar />
      <div className="p-4 flex-grow-1" style={{ overflowX: "auto" }}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default PrivateRoute;
